import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ExcelMaterialImport.frontend.types'

@Injectable({ providedIn: 'root' })
export class ExcelMaterialImport_footprint_generic_json_material_to_entity_import_xml_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { material?: $frontendTypes.ExcelMaterialImport.DatexMaterialInfo, transaction_id?: string, source_lookup_code?: string, source_platform?: string }): Promise<{ messages?: string[], project?: string, payload_xml?: string, payload_json?: any }> 
  {
    let url = `${environment.backendUrl}api/ExcelMaterialImport/functions/footprint_generic_json_material_to_entity_import_xml_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

